import React, { createContext, useContext, useMemo } from 'react';
import { esCopy } from '../data/copy/es';
import { enCopy } from '../data/copy/en';
import type { Copy, Language } from '../types/copy';
const DICTIONARIES: Record<Language, Copy> = {
  es: esCopy,
  en: enCopy
};
const LanguageContext = createContext<Copy>(esCopy);
interface LanguageProviderProps {
  language: Language;
  children: React.ReactNode;
}
export function LanguageProvider({
  language,
  children
}: LanguageProviderProps) {
  const copy = useMemo(() => DICTIONARIES[language] ?? esCopy, [language]);
  return <LanguageContext.Provider value={copy} data-id="element-44" data-mp="z7hd7l1ljtcf">{children}</LanguageContext.Provider>;
}

/** Devuelve el diccionario de textos del idioma activo. */
export function useCopy(): Copy {
  return useContext(LanguageContext);
}